import { Radio, Space } from "antd";

import { StepContainer } from "./styles";

const notCopyable = (recipient) => !recipient.support_alerts || recipient.support_alerts.length === 0;

// The copy flow: pick a recipient whose alerts should be copied onto the new one.
const CopyStep = ({ copyableRecipients, copyStaffId, setCopyStaffId }) => (
  <StepContainer>
    <div>
      <p>Choose whose alerts to copy. The new recipient will receive a copy of every alert that recipient has.</p>
    </div>
    <Radio.Group id="copy-source" value={copyStaffId} onChange={(e) => setCopyStaffId(e.target.value)}>
      <Space direction="vertical">
        {copyableRecipients.map((recipient) => (
          <Radio key={recipient.id} value={recipient.id} disabled={notCopyable(recipient)}>
            {recipient.name}
            {notCopyable(recipient) ? " (no alerts to copy)" : ""}
          </Radio>
        ))}
      </Space>
    </Radio.Group>
  </StepContainer>
);

export default CopyStep;
